<!--The content below is only a placeholder and can be replaced.-->

<div id="wrapper">
    <div class="container-fluid" style="padding-left: 0px; padding-right: 0px; background: #ac172b" >
        <div class="sidebar-menu">
            <ara-menu></ara-menu>
        </div>
        <div class="main-content">
            <div class="row">
                <ara-header></ara-header>
            </div>
        
            <div class="main-content-body">
                <router-outlet></router-outlet>
            </div>
            <ara-footer></ara-footer>
        </div>
        <!-- <ara-header></ara-header>
        <router-outlet></router-outlet> -->
        <ara-notifications></ara-notifications>
    </div>
</div>
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}" pTooltip="Scroll To Top">
    <button (click)="scrollToTop()" class="btn btn-secondary scroll-btn" aria-label="Scroll To Top">
        <i class="fa fa-chevron-up"></i>
    </button>
</div>